export const SOURCE_ID = window._env_.SOURCE_ID;
export const BACKEND_URL = window._env_.BACKEND_URL;
export const LIVECHAT_LICENSE = parseInt(window._env_.LIVECHAT_LICENSE);
export const STRIPE_PUBLISHABLE_KEY = window._env_.STRIPE_PUBLISHABLE_KEY;